import { render, staticRenderFns } from "./ProceduresEdit.vue?vue&type=template&id=f47faa24"
import script from "./ProceduresEdit.vue?vue&type=script&lang=js"
export * from "./ProceduresEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports